import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {
    BonusConfig,
    BonusConfigListResponse,
    UserLimitFigure
} from "../http/protocol";


export class BonusConfigService  extends AbstractAdminEntityService<BonusConfig, BonusConfigListResponse>  {

    constructor(http : HttpService) {
        super("/bonus/config", http)
    }

    getUserFigure(id : number, userId : number) : Promise<UserLimitFigure> {
        return this.http.get(id + "/figure/user/" + userId);
    }

}